import { UpdateCargoClaimCommand } from "@amzn/ttechclaimintakeservice-client";

import { getAuthenticationToken } from "../../auth/helpers";
import { setupClaimIntakeClient } from "../setup/setupClaimIntakeClient";
import { MetricsPublisher } from "../../metrics/metrics";
import { ProcessedApiResponse } from "../types";
import { updateCargoClaimModelBuilder } from "./CargoClaimModelBuilder";
import { FormStateType } from "src/forms/types";
import { CargoClaimAdditionalFields } from "src/app/Cargo/types";

export async function updateCargoClaimService(
  formState: FormStateType,
  additionalFields: CargoClaimAdditionalFields
) {
  const token = await getAuthenticationToken();
  if (!token) {
    return null;
  }

  const commandInput = updateCargoClaimModelBuilder(formState, additionalFields);
  const client = setupClaimIntakeClient(token);
  const command = new UpdateCargoClaimCommand(commandInput);
  const metricsPublisher = new MetricsPublisher("api.updateCargoClaim");

  return await client
    .send(command)
    .then((response) => {
      const resp = response as typeof response & { warningList?: string[]; claimNumber?: string };
      const statusCode = resp?.$metadata?.httpStatusCode?.toString();
      const processedResponse: ProcessedApiResponse = {
        statusCode,
        warningList: resp.warningList,
        data: [
          {
            fieldName: "Claim Reference Number",
            fieldValue: resp.claimNumber,
          },
        ],
      };
      metricsPublisher.publishAuthenticationLatencyMetrics();
      metricsPublisher.publishRenderSuccessMetrics();
      return processedResponse;
    })
    .catch((error) => {
      metricsPublisher.publishAuthenticationLatencyMetrics();
      metricsPublisher.publishRenderFatalMetrics();
      throw error;
    });
}
